"use client";

import flatpickr from "flatpickr";
import { CustomLocale } from "flatpickr/dist/types/locale";
import { default as English } from "flatpickr/dist/l10n/default.js";
import { German } from "flatpickr/dist/l10n/de.js";
import { French } from "flatpickr/dist/l10n/fr.js";
import { Italian } from "flatpickr/dist/l10n/it.js";

const localeMap: Record<string, CustomLocale> = {
  en: English,
  de: German,
  fr: French,
  it: Italian,
};

export const getFlatpickrLocale = (language: string | undefined) => {
  if (!language) return English;
  const normalized = language.toLowerCase();
  const base = normalized.split("-")[0];
  return localeMap[normalized] || localeMap[base] || English;
};

export const localizeFlatpickr = (language: string | undefined) => {
  flatpickr.localize(getFlatpickrLocale(language));
};

